import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import Language from '../../../../../types/language/Language';
import LanguageWriteDTO from '../../../../../types/language/LanguageWriteDTO';
import { IsAdminDirective } from '../../../directives/is-admin.directive';
import { RoleNamePipe } from '../../../pipes/role-name.pipe';
import { LanguageService } from '../../../services/language.service';
import {
    UpdateLanguageDialogComponent
} from '../../shared/languages/update-language-dialog/update-language-dialog.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
    selector: 'app-language-detail',
    templateUrl: './language-detail.component.html',
    styleUrls: [ './language-detail.component.scss' ],
    imports: [
        Button,
        RouterLink,
        PageHeaderComponent,
        UpdateLanguageDialogComponent,
        RoleNamePipe,
        IsAdminDirective
    ]
})
export class LanguageDetailComponent implements OnInit {
    public language: Language | null = null;
    public editableLanguage: LanguageWriteDTO = new LanguageWriteDTO({});
    public displayUpdateDialog = false;

    constructor(
        private route: ActivatedRoute,
        private languageService: LanguageService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService
    ) {
    }

    /**
     * Initializes the component.
     */
    public ngOnInit(): void {
        this.loadLanguage();
    }

    /**
     * Opens the edit dialog.
     */
    public openEditDialog(): void {
        this.editableLanguage = new LanguageWriteDTO(this.language ?? {});
        this.displayUpdateDialog = true;
    }

    /**
     * Reloads the language details.
     */
    public reloadLanguageDetails(): void {
        this.loadLanguage();
    }

    /**
     * Confirms the deletion of the language.
     */
    public confirmDelete(): void {
        if (!this.language) {
            return;
        }

        this.confirmationService.confirm({
            message: `Are you sure you want to delete the language '${ this.language.name }'?`,
            header: 'Confirm Deletion',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.languageService.deleteLanguage(this.language!.id).then(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Deleted',
                        detail: 'Language deleted successfully',
                        life: 3000
                    });
                    // Navigate back to the languages page
                    window.history.back();
                }).catch((error: any) => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
                });
            }
        });
    }

    /**
     * Loads the language details.
     */
    private loadLanguage(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            const idNumber = parseInt(id);
            this.languageService.getLanguage(idNumber).then((result: Language) => {
                this.language = result;
            }).catch((error: any) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            });
        }
    }

}
